import tw from "twin.macro"

export const H5 = tw.h5`
 text-header 
 text-center 
 font-sans
 text-xl
 `
